import React from 'react';

import { MotifSortieViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { MotifSortieFormValues } from 'types/referentiels/MotifSortie';

import { buildRequestDto } from '../utils';

import { ModalEditionMotifSortie } from './ModalEditionMotifSortie';

interface ModalDetailsProps {
  visible: boolean;
  close: () => void;
  refreshDashboard: () => void;
}

function ModalCreate({
  visible,
  close,
  refreshDashboard,
}: ModalDetailsProps): React.ReactElement {
  const initials: MotifSortieFormValues = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: MotifSortieFormValues) =>
      AdminFonctionnelControllerApi.createMotifSortieUsingPOST(
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: MotifSortieViolationDtoFormFieldEnum,
      values: MotifSortieFormValues,
    ) =>
      AdminFonctionnelControllerApi.validateCreateMotifSortieFieldUsingPOST(
        field,
        buildRequestDto(values),
      ),
    response => response.motifSortieViolationsDto ?? [],
  );

  return (
    <ModalEditionMotifSortie
      close={close}
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      visible={visible}
      title={'Créer un motif de sortie'}
      validate={validate}
    />
  );
}

export default ModalCreate;
